// This file contains compile-time defined variables.

export const NAME = '#{NAME}';

export const VERSION = '#{VERSION}';
